export function DefaultErrorScreen() {
    return <div>An unexpected error occured.</div>;
}
export default DefaultErrorScreen;
